(() => {
  const boot = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const cards = [...root.querySelectorAll('[data-builder-product]')];
    const form = root.querySelector('[data-builder-form]');
    const list = root.querySelector('[data-builder-list]');
    const total = root.querySelector('[data-builder-total]');
    const submit = root.querySelector('[data-builder-submit]');
    const msg = root.querySelector('[data-builder-message]');
    const cart = root.querySelector('[data-builder-cart]');
    const filter = root.querySelector('[data-builder-filter]');
    const count = root.querySelector('[data-builder-count]');
    const empty = root.querySelector('[data-builder-empty]');
    const nameInput = root.querySelector('[data-is-name]');
    const titleInput = root.querySelector('[data-is-title]');
    const fontInput = root.querySelector('[data-is-font]');
    const share = root.querySelector('[data-builder-share]');
    const extraCards = cards.filter((card) => card.dataset.kind === 'extra');
    const money = new Intl.NumberFormat(root.dataset.locale || 'tr-TR', {
      style: 'currency',
      currency: root.dataset.currency || 'TRY',
    });

    let busy = false;
    let completed = false;

    const selectedVariant = (card) => card.querySelector('[data-builder-variant]:checked');

    const chosen = () =>
      cards
        .filter((card) => card.querySelector('[data-builder-toggle]')?.checked)
        .map((card) => {
          const option = selectedVariant(card);
          return {
            card,
            id: Number(option?.value),
            title: option?.dataset.title || card.dataset.title,
            price: Number(option?.dataset.price || 0),
            kind: card.dataset.kind,
          };
        })
        .filter((item) => item.id);

    const render = () => {
      const items = chosen();
      const hasBase = items.some((item) => item.kind === 'base');
      list.replaceChildren();

      if (!items.length) {
        const li = document.createElement('li');
        li.innerHTML = `<span>${root.dataset.emptyText || 'Önce ana sümeninizi seçin.'}</span>`;
        list.append(li);
      }

      let sum = 0;
      items.forEach((item) => {
        sum += item.price;
        const li = document.createElement('li');
        const label = document.createElement('span');
        label.textContent = `${item.title} · ${money.format(item.price / 100)}`;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = root.dataset.removeText || 'Kaldır';
        remove.addEventListener('click', () => {
          const toggle = item.card.querySelector('[data-builder-toggle]');
          if (toggle) toggle.checked = false;
          item.card.classList.toggle('is-selected', false);
          changed();
        });
        li.append(label, remove);
        list.append(li);
      });

      const formatted = money.format(sum / 100);
      total.textContent = formatted;
      submit.disabled = !hasBase || busy || completed;
    };

    const changed = () => {
      completed = false;
      submit.textContent = root.dataset.submitText || 'Seçimimi sepete ekle';
      if (msg) msg.hidden = true;
      if (cart) cart.hidden = true;
      cards.forEach((card) => {
        const on = card.querySelector('[data-builder-toggle]')?.checked === true;
        card.classList.toggle('is-selected', on);
      });
      render();
      writeUrl();
    };

    const writeUrl = () => {
      const items = chosen();
      const params = new URLSearchParams();
      if (items.length) params.set('s', items.map((item) => item.id).join(','));
      
      
      const font = fontInput?.value;
      
      
      if (font) params.set('f', font);
      const next = params.toString();
      const url = next ? `${location.pathname}?${next}` : location.pathname;
      history.replaceState(null, '', url);
      return location.href;
    };

    const restore = () => {
      const params = new URLSearchParams(location.search);
      const ids = (params.get('s') || '').split(',').filter(Boolean);
      if (params.get('n') && nameInput) nameInput.value = params.get('n');
      if (params.get('u') && titleInput) titleInput.value = params.get('u');
      if (params.get('f') && fontInput) fontInput.value = params.get('f');
      if (!ids.length) return;
      cards.forEach((card) => {
        const variants = [...card.querySelectorAll('[data-builder-variant]')];
        const match = variants.find((input) => ids.includes(input.value));
        const toggle = card.querySelector('[data-builder-toggle]');
        if (match && toggle) {
          match.checked = true;
          toggle.checked = true;
        }
      });
    };

    const applyFilter = () => {
      const q = (filter?.value || '').trim().toLocaleLowerCase('tr');
      let visible = 0;
      extraCards.forEach((card) => {
        const match = !q || (card.dataset.title || '').toLocaleLowerCase('tr').includes(q);
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (count) count.textContent = String(visible);
      if (empty) empty.hidden = visible !== 0;
    };

    cards.forEach((card) => {
      card.querySelector('[data-builder-toggle]')?.addEventListener('change', changed);
      card.querySelectorAll('[data-builder-variant]').forEach((input) => {
        input.addEventListener('change', changed);
      });
      card.addEventListener('click', (event) => {
        if (event.target.closest('label, input, button, a')) return;
        const toggle = card.querySelector('[data-builder-toggle]');
        if (!toggle) return;
        toggle.checked = toggle.type === 'radio' ? true : !toggle.checked;
        toggle.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    filter?.addEventListener('input', applyFilter);
    nameInput?.addEventListener('input', writeUrl);
    titleInput?.addEventListener('input', writeUrl);
    fontInput?.addEventListener('change', writeUrl);
    share?.addEventListener('click', async () => {
      const url = writeUrl();
      try {
        await navigator.clipboard.writeText(url);
        share.textContent = root.dataset.copiedText || 'Link kopyalandı';
      } catch (error) {
        window.prompt(root.dataset.shareText || 'Seçki linki', url);
      }
    });

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const items = chosen();
      if (busy || !items.some((item) => item.kind === 'base')) return;
      busy = true;
      const group = 'KS-' + Date.now().toString(36).toUpperCase();
      submit.textContent = root.dataset.busyText || 'Sepete ekleniyor…';
      render();
      const name = nameInput?.value.trim() || '';
      const title = titleInput?.value.trim() || '';
      const font = fontInput?.value || '';
      try {
        const payload = {
          items: items.map((item) => {
            const properties = {
              Seçki: 'Kendi Sümenim',
              'Seçki kodu': group,
            };
            if (item.kind === 'base') {
              if (name) properties.İsim = name;
              if (title) properties.Ünvan = title;
              if (font && (name || title)) properties['Yazı tipi'] = font;
            }
            return { id: item.id, quantity: 1, properties };
          }),
        };
        const response = await fetch(root.dataset.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.errorText || 'Ürünler eklenemedi.');
        completed = true;
        if (msg) {
          msg.textContent = root.dataset.successText || 'Seçkiniz sepete eklendi.';
          msg.hidden = false;
        }
        if (cart) cart.hidden = false;
      } catch (error) {
        if (msg) {
          msg.textContent = error.message || root.dataset.errorText || 'Ürünler eklenemedi, lütfen tekrar deneyin.';
          msg.hidden = false;
        }
      } finally {
        busy = false;
        submit.textContent = completed
          ? root.dataset.doneText || 'Seçki sepete eklendi'
          : root.dataset.submitText || 'Seçimimi sepete ekle';
        render();
      }
    });

    restore();
    applyFilter();
    changed();
  };

  const start = (scope = document) => {
    scope.querySelectorAll('[data-builder-root]').forEach(boot);
  };

  start();
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
